var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 405,
    height: 405,
    viewBox: "0 0 405 405",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3419 202.37C21.3419 102.391 102.391 21.3419 202.37 21.3419C302.349 21.3419 383.398 102.391 383.398 202.37C383.398 302.349 302.349 383.398 202.37 383.398C102.391 383.398 21.3419 302.349 21.3419 202.37ZM202.37 0.0227022C90.6166 0.0227022 0.0227022 90.6166 0.0227022 202.37C0.0227022 314.123 90.6166 404.717 202.37 404.717C314.123 404.717 404.717 314.123 404.717 202.37C404.717 90.6166 314.123 0.0227022 202.37 0.0227022ZM156.822 170.471C155.094 172.165 153.385 173.84 151.926 175.664C156.08 201.776 183.973 227.295 197.622 237.977C197.886 238.193 198.17 238.426 198.473 238.675C205.668 244.582 223.501 259.222 232.043 256.375C234.873 255.431 238.265 251.77 242.07 247.663C247.842 241.435 254.563 234.181 261.716 233.823C268.837 233.823 291.389 251.034 294.95 254.594C304.182 265.456 292.541 277.808 285.496 285.285C284.842 285.978 284.228 286.63 283.674 287.235C262.903 308.006 237.977 299.104 207.711 284.267C163.795 262.309 124.033 222.547 108.603 168.543C97.3274 128.781 131.748 102.669 144.804 105.636C153.03 107.692 158.583 123.554 162.622 135.09C163.245 136.871 163.833 138.549 164.388 140.057C170.522 157.043 163.526 163.9 156.822 170.471Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCell);
export default __webpack_public_path__ + "static/media/cell.adfed42f67403c6c1cdcacfbb4536f5e.svg";
export { ForwardRef as ReactComponent };